import './UpscaleControl.sass'

import * as React from 'react'

interface UpscaleControlProps {
  active: string,
  onChange(upscaleValue: string): void
}

const items = ['x2', 'x4', 'x8', 'custom']

const UpscaleControl: React.SFC<UpscaleControlProps> = ({ onChange, active }) => {
  return (
    <div className='upscale-control'>
      {items.map((item: string) => {
        const handleClick = () => onChange(item)
        const isActive = active === item ? 'active' : ''

        return <div className={`upscale-item ${isActive}`} key={item} onClick={handleClick}>{item}</div>
      })}
    </div>
  )
}

export default UpscaleControl
